
import { BlogSection } from '@/types/blog';

export const introSection: BlogSection = {
  id: 'intro',
  title: 'Künstliche Intelligenz: Chancen, Risiken und dein Weg zur finanziellen und emotionalen Unabhängigkeit',
  content: `
    <p>
      Die künstliche Intelligenz (KI) verändert gerade alles – von Finanzmärkten über das Gesundheitswesen bis hin zu deiner persönlichen Entscheidungsfindung. Unternehmer:innen, Führungskräfte und Privatpersonen stehen gleichermaßen vor der Frage: Wie beeinflusst KI meine finanziellen Entscheidungen und meine emotionale Stabilität? Wer sich frühzeitig mit den Potenzialen und Risiken auseinandersetzt, trifft nicht nur bessere finanzielle Entscheidungen, sondern stärkt auch seine emotionale Intelligenz.
    </p>
  `
};
